
export default {
  name: 'rzMobileDrawer',
  props: {
    type: String,
    default: 'Вход \ Регистрация',
  },
  methods: {
    close() {
      this.$emit('close');
    },
    profileClick() {
      if (this.isUser) {
        if (this.$route.name === 'profile') {
          this.close();
        } else {
          this.$emit('profile');
        }
        return;
      }
      this.$router.push({ name: 'login' });
    },
  },
};
